export const LOADING_WORKFLOWS = 'LOADING_WORKFLOWS';
export const LOADING_WORKFLOW = 'LOADING_WORKFLOW';
export const LOADING_COPY_WORKFLOW = 'LOADING_COPY_WORKFLOW';
export const SAVE_LOADING_WORKFLOWS = 'SAVE_LOADING_WORKFLOWS';
export const GET_WORKFLOWS = 'GET_WORKFLOWS';
export const GET_WORKFLOW = 'GET_WORKFLOW';
export const WORKFLOW_FAIL = 'WORKFLOW_FAIL';
export const WORKFLOW_FORM_FAIL = 'WORKFLOW_FORM_FAIL';
